<template>
  <!--  col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12-->
  <v-col class="d-flex justify-space-between align-center" :class="colClass">
    <span class="field-title" v-if="!isPropsTitle">{{ title }}</span>
    <slot></slot>
  </v-col>
</template>

<script>
import _ from "lodash";

export default {
  name: "FieldInput",
  props: ["title", "cols"],
  computed: {
    isPropsTitle() {
      return _.isEmpty(this.title);
    },
    colClass() {
      if (this.cols === "2") {
        return "col-xl-2 col-lg-4 col-md-4 col-sm-6 col-12";
      }
      if (this.cols === "3") {
        return "col-xl-3 col-lg-4 col-md-5 col-sm-6 col-12";
      }
      if (this.cols === "4") {
        return  "col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12";
      }
      if (this.cols === "6") {
        return  "col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12";
      }
      return "col-12";
    }
  }
}
</script>

<style>
.field-title {
  font-size: min(3.5vw, 15px);
  min-width: 80px;
}
</style>